import styled from 'styled-components';
import constants from '../../../../../../core/constants';

const WrapSummaryList = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  .wrapSummary {
    width: 264px;
    margin-bottom: 8px;
    display: flex;
  }

  .gridSummaries {
    width: 100%;
    display: flex;
    flex-direction: row;
    // flex-wrap: wrap;
    // overflow: auto;
    overflow-x: scroll;
    gap: 24px;
    padding-right: 16px;
  }
  .gridSummaries::-webkit-scrollbar {
    display: none;
  }
  .summary {
  }

  .summary > * {
    display: flex;
  }

  .titleProcedure {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  @media (min-width: 768px) {
    .gridSummaries {
      // padding-left: 24px;
    }
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    .gridSummaries {
      /* max-width: 1144px; */
      // padding-left: 32px;
      padding-right: 32px;
    }
    .wrapSummary {
      width: 264px;
    }

    .wrapSummary:nth-child(4n) {
      flex-grow: inherit;
    }

    .wrapSummary {
      // padding-left: 12px;
      // padding-right: 12px;
    }
    .summary {
      // width: 100%;
      justify-content: space-between;
    }
  }

  @media (min-width: 1280px) {
    .gridSummaries {
      padding-right: 0px;
      padding-left: 0px;
    }
  }
`;

export { WrapSummaryList };
